import { AppUser } from "../models/utilities/app-user";
import { SelectListItem } from "../models/utilities/selectlist-item";
import { ServiceCenter } from "../models/utilities/service-center";
import { IApplicationState } from "../store/IApplicationState";

export const getCurrentUser = (state:IApplicationState) : AppUser => 
    state.userdata.user;

export const getCurrentServiceCenter = (state: IApplicationState) : ServiceCenter|undefined => {
    if(!state.userdata || !state.userdata.activeServiceCenter || state.userdata.activeServiceCenter.id === 0){
        return undefined;
    }
    
    return state.userdata.activeServiceCenter;
}

export const serviceCenterSelectList = (state: IApplicationState) : Array<SelectListItem<string>>  => {
    
    const available = state.utility.appServiceCenters;
    const usersAllowed = state.userdata.user.serviceCenters;

    const scList : Array<SelectListItem<string>> = [];

    for(const sc of usersAllowed) {

        // For a user with all, we want to return a list of all the service
        // centers with the All option removed.
        if(sc === 'ALL') {
            const mapped = available.reduce((acc:Array<SelectListItem<string>>, itm: ServiceCenter) => {
                if(itm.name !== 'ALL') {
                    acc.push(new SelectListItem<string>({id: itm.name, name: itm.description}));
                }          
                return acc;
            }, []);
            
            return mapped;
        }

        const tmp = available.find((itm:ServiceCenter) => {
            return itm.name === sc;
        });

        if(tmp) {
            scList.push(new SelectListItem({ id: tmp.name, name: tmp.description }));
        }
    }

    return scList;
}